import { Button } from "@shltelemedicine/shl-ui-lib";
import { FormattedMessage } from "react-intl";
import logoutIcon from "../../assets/nav/logout.svg";
import { AuthActionType, useAuthContext } from "../../context/AuthContext";
import useAppScopes from "../../hooks/useAppScopes";
import authService from "../../services/authentication.service";
import { delay } from "../../utils/sharedUtil";
import styles from "./UserInfo.module.css";

type UserInfoProps = {
  showName?: boolean;
};

const UserInfo = ({ showName }: UserInfoProps) => {
  const {
    state: { user },
    dispatch: authDispatch,
  } = useAuthContext();

  const {
    scopesState: { uniqueIdActive },
  } = useAppScopes();

  const logout = async () => {
    authService.logout("manual");

    /**
     * TODO:
     * ## Fix SSO logout issue ##
     * Adding slight delay to allow logout operation to complete
     */
    await delay(500);

    authDispatch({
      type: AuthActionType.LOGOUT,
    });
  };

  const initials = `${(user?.firstName ?? "").charAt(0)}${(
    user?.lastName ?? ""
  ).charAt(0)}`;

  return (
    <div className="d-flex align-items-center">
      <div
        className={`${styles.initials} rounded-circle p-1 d-flex align-items-center justify-content-center`}
      >
        <span>{initials}</span>
      </div>
      <div className="mx-1"></div>
      <div>
        {showName && (
          <p className={`${styles.name} mb-0 font-md`}>
            {user?.firstName} {user?.lastName}
          </p>
        )}
        {!uniqueIdActive && (
          <div className="d-sm-flex align-items-center">
            <Button
              icon={{ src: logoutIcon, width: 14, height: 14 }}
              variant="link"
              className={`${styles.logoutBtn} p-0 text-decoration-link`}
              size="sm"
              onClick={logout}
            >
              <FormattedMessage id="NAV.LOGOUT" defaultMessage="Logout" />
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserInfo;
